import { Separator } from '@/shared/ui';
import { TimeRangeSelector, UserMenu } from './TopBarControls';

export function TopBar() {
  return (
    <header className="z-sticky flex h-16 shrink-0 items-center justify-end gap-4 border-b border-border bg-surface/80 px-5 backdrop-blur">
      <div className="flex items-center gap-3">
        <TimeRangeSelector />
        <Separator orientation="vertical" className="h-6" />
        <UserMenu />
      </div>
    </header>
  );
}
